import {
  CollectionFragment,
  FeaturedItemFragment,
} from 'types/api/dato-operations.types';

import { CityCardType } from 'components/@events/types';
import HomeCities from 'components/@home/HomeCities';
import HomeCollections from 'components/@home/HomeCollections';
import HomeEvents from 'components/@home/HomeEvents';
import HomeFeaturedItems from 'components/@home/HomeFeaturedItems';
import PageBreadcrumbs from 'components/@navigation/PageBreadcrumbs';

interface Props {
  cities: Array<CityCardType>;
  featuredItems?: Array<FeaturedItemFragment>;
  collections?: Array<CollectionFragment>;
}

const HomeContainer = ({ cities, featuredItems, collections }: Props) => {
  return (
    <>
      <PageBreadcrumbs hideOnDesktop />
      <HomeFeaturedItems featuredItems={featuredItems} />
      <HomeCollections collections={collections} />
      <HomeCities cities={cities} />
      <HomeEvents />
    </>
  );
};

export default HomeContainer;
